module.exports = __webpack_public_path__ + "static/promo-video-cover-1dac5c41952596e04bc0f6c3057908fd.jpg";